module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "Contents.html",
      "xml:lang": "en-US"
    }
  }, [_c('div', {
    staticClass: "Basic-Text-Frame-1"
  }, [_c('p', {
    staticClass: "image-fl"
  }, [_c('span', {
    staticClass: "a-head-italics"
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "alt": "birdonstem.tif",
      "src": "images/birdonstem_fmt.png",
      "width": "37%"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "x1toc",
    attrs: {
      "id": "toc_marker-6"
    }
  }, [_c('span', {
    staticClass: "a-head-italics",
    staticStyle: {
      "font-size": "0.93em"
    }
  }, [_vm._v("table of ")]), _c('br'), _vm._v("Contents"), _c('a', {
    attrs: {
      "id": "x-contents-"
    }
  })]), _c('a', {
    attrs: {
      "id": "x-contents-"
    }
  }, [_c('p', {
    staticClass: "swoosh-toc"
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "alt": "633.jpg",
      "src": "images/633.jpg",
      "width": "10%"
    }
  })])]), _c('p', {
    staticClass: "TOC-chapter-titles"
  }, [_c('a', {
    attrs: {
      "id": "x-contents-"
    }
  }), _c('a', {
    attrs: {
      "href": "#/SeasonsWitchery#Introduction"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-chapter-titles"
  }, [_c('a', {
    attrs: {
      "href": "#/SeasonsWitchery1#Anchor"
    }
  }, [_vm._v("Chapter 1")]), _vm._v(": Midsummer/Summer Solstice")]), _vm._v(" "), _c('p', {
    staticClass: "TOC-chapter-titles"
  }, [_c('a', {
    attrs: {
      "href": "#/SeasonsWitchery2#Anchor-3"
    }
  }, [_vm._v("Chapter 2")]), _vm._v(": Lughnasadh/Lammas")]), _vm._v(" "), _c('p', {
    staticClass: "TOC-chapter-titles"
  }, [_c('a', {
    attrs: {
      "href": "#/SeasonsWitchery3#Anchor-4"
    }
  }, [_vm._v("Chapter 3")]), _vm._v(": Autumn Equinox/Mabon ")]), _vm._v(" "), _c('p', {
    staticClass: "TOC-chapter-titles"
  }, [_c('a', {
    attrs: {
      "href": "#/SeasonsWitchery4#Anchor-5"
    }
  }, [_vm._v("Chapter 4")]), _vm._v(": Samhain/Halloween ")]), _vm._v(" "), _c('p', {
    staticClass: "TOC-chapter-titles"
  }, [_c('a', {
    attrs: {
      "href": "#/SeasonsWitchery5#Anchor-6"
    }
  }, [_vm._v("Chapter 5")]), _vm._v(": Yule/Winter Solstice ")]), _vm._v(" "), _c('p', {
    staticClass: "TOC-chapter-titles"
  }, [_c('a', {
    attrs: {
      "href": "#/SeasonsWitchery6#Anchor-7"
    }
  }, [_vm._v("Chapter 6")]), _vm._v(": Imbolc/Candlemas ")]), _vm._v(" "), _c('p', {
    staticClass: "TOC-chapter-titles"
  }, [_c('a', {
    attrs: {
      "href": "#/SeasonsWitchery7#Anchor-8"
    }
  }, [_vm._v("Chapter 7")]), _vm._v(": Vernal Equinox/Ostara ")]), _vm._v(" "), _c('p', {
    staticClass: "TOC-chapter-titles"
  }, [_c('a', {
    attrs: {
      "href": "#/SeasonsWitchery8#Anchor-9"
    }
  }, [_vm._v("Chapter 8")]), _vm._v(": Beltane ")]), _vm._v(" "), _c('p', {
    staticClass: "TOC-chapter-titles"
  }, [_c('a', {
    attrs: {
      "href": "#/SeasonsWitchery9#Anchor-10"
    }
  }, [_vm._v("Afterword")]), _vm._v(": Reflections on the Past Year")]), _vm._v(" "), _c('p', {
    staticClass: "TOC-chapter-titles"
  }, [_c('span', {
    attrs: {
      "href": "#/Acks#Acknowledgments",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-chapter-titles"
  }, [_c('a', {
    attrs: {
      "href": "#/SeasonsWitchery10#Anchor-11"
    }
  }, [_vm._v("Appendix")]), _c('span', [_vm._v(": ")]), _vm._v("Sabbat Correspondences ")]), _vm._v(" "), _c('p', {
    staticClass: "TOC-chapter-titles"
  }, [_c('a', {
    attrs: {
      "href": "#/SeasonsWitchery11#Anchor-12"
    }
  }, [_vm._v("Glossary")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-chapter-titles"
  }, [_c('a', {
    attrs: {
      "href": "#/SeasonsWitchery12#Anchor-13"
    }
  }, [_vm._v("Bibliography")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a3ddcc0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Contents.vue
// module id = 72
// module chunks = 0